<template>
  <div class="auth-inner-page">
    <div class="container">
      <div class="col-lg-4 col-md-6 ml-auto mr-auto">
        <div class="text-center">
          <img class="logo" :src="'/gpassist/img/logo-hunika.png'" alt />
        </div>
        <form @submit.prevent="login">
          <card class="card-white">
            <template slot="header">
              <h3 class="card-title">Log in</h3>
            </template>

            <div>
              <base-input
                v-validate="'required|email'"
                name="email"
                :class="{'is-valid': getError('email')}"
                v-model="email"
                placeholder="Email"
                addon-left-icon="tim-icons icon-email-85"
              ></base-input>
              <small
                class="text-danger mb-2 d-block"
                v-if="errors.has('email')"
              >Favor digitar un email válido</small>

              <base-input
                v-validate="'required|min:5'"
                name="password"
                :class="{'is-valid': getError('password')}"
                v-model="password"
                type="password"
                placeholder="Password"
                addon-left-icon="tim-icons icon-lock-circle"
              ></base-input>
              <small
                class="text-danger mb-2 d-block"
                v-if="errors.has('password')"
              >Favor digitar una contraseña con mínimo 5 dígitos</small>
            </div>

            <div slot="footer">
              <base-button
                native-type="submit"
                type="primary"
                class="mb-3"
                block
                :loading="loading"
              >Login</base-button>
              <base-button
                type="info"
                class="mb-3"
                block
                :loading="msLoading"
                @click="onMicrosoftLogin"
              >Iniciar sesión con Microsoft</base-button>
              <p class="text-center">
                <small>
                  ¿Has olvidado tu contraseña?
                  <router-link class="link footer-link" :to="{name: 'resetpassword'}">Recupérala</router-link>
                </small>
              </p>

              <div class="text-center" hidden>
                <a href="javascript:void(0)" class="link footer-link">¿Necesitas Ayuda?</a>
              </div>
            </div>
          </card>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      email: "",
      password: "",
      loading: false,
      msLoading: false
    };
  },
  computed: {},
  methods: {
    getError(fieldName) {
      return !this.errors.first(fieldName) == "";
    },

    onMicrosoftLogin() {
      this.msLoading = true;
      this.$store
        .dispatch("loginMicrosoft")
        .then(response => {
          this.msLoading = false;
          if (response && response.data && response.data.resultCode == 0) {
            this.$store.dispatch("getMenus");
            this.$store.dispatch("getUserData");
            this.$router.push({ name: "mytickets" });
          } else {
            const errors =
              response && response.data ? response.data.resultMessages : null;
            this.$notify({
              type: "danger",
              message:
                errors && errors.length
                  ? errors.join(",<br />")
                  : "No fue posible iniciar sesión con Microsoft"
            });
          }
        })
        .catch(() => {
          this.msLoading = false;
          this.$notify({
            type: "danger",
            message: "Inicio de sesión con Microsoft cancelado o fallido"
          });
        });
    },

    login() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.loading = true;
          // this.$store.commit("SET_MENUS", []);
          this.$store
            .dispatch("login", {
              email: this.email,
              password: this.password
            })
            .then(response => {
              this.loading = false;
              if (response && response.data) {
                if (response.data.resultCode == 0) {
                  this.$store.dispatch("getMenus").then(response => {
                    this.$store.dispatch("getMenus");
                    this.$store.dispatch("getUserData");
                    this.$router.push({ name: "mytickets" });
                  });
                } else {
                  const errors = response.data.resultMessages;
                  if (errors && errors.length > 0) {
                    const message = errors.join(",<br />");
                    this.$notify({
                      type: "danger",
                      message: message
                    });
                  }
                }
              } else {
                this.$notify({
                  type: "danger",
                  message: "Usuario inválido"
                });
              }
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>
 <style lang="scss" src="./auth.scss"></style>
